import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PlacesAutoComplete from 'Components/PlacesAutoComplete';
import Input from "Components/Input";
import Dropdown from "Components/Dropdown";
import AddOtherCosts from 'Components/SecondaryTripTable/AddOtherCost';
import Trip from 'Models/Trip';
import { TAT_UNITS, EMAMI } from "Constants/commonConstants";
import { GET_ROUTE_CODE, SAVE_ROUTE_CODE, GET_LPP_DETAILS } from "Constants/actionConstants";
import ResponsiveTable from "Components/ResponsiveTable";
import Slab from "Models/SecSlab";
import Cx from 'classnames';
import { toPascalCase } from '../../utils/validate'
import { isAdaniWilmar, isSapDPL } from 'Utils/index';
import { getUser } from 'Utils/storage';

class SecondaryAddTrip extends Component {
   constructor(props) {
      super(props);
      const trip = props.trip || new Trip();
      if (!props.trip) {
        trip.addStop();
        trip.addStop();
         // trip.addSlab();
         // trip.multiModeHeadingCharges.push({
         //     headingChargesDescription : '',
         //     headingChargesBudget: '',
         //     headingChargesUnit: '',
         //     headingChargesMr: '',
         //     headingChargesLpp: '',
         //     headingChargesCp: '',
         //     headingChargesValue: ''
         // }
      }
      if(isAdaniWilmar()) {
         const branchId = ((props.selectedNavBranch || {}).branch_id ||  getUser().branchId);
         let findBranch = (props.depotLocationList || []).find(depot => depot.branch_id === branchId);
         if(!findBranch) {
            findBranch = (props.plantLocationList || []).find(depot => depot.branch_id === branchId);
         }
         if(findBranch) {
            if(!findBranch.landmark) {
               findBranch.landmark = findBranch.address;
            }
            trip.stops[0].setLocation(findBranch);
            trip.stops[0].landmark = `${findBranch.landmark}${findBranch.pincode ? `, ${findBranch.pincode}`: ''}`;
         }
      }
      console.log('trip', trip);
      this.state = {
         trip
      }
   }

   UNSAFE_componentWillReceiveProps(nextProps) {
      const { trip } = this.state;
      if(isAdaniWilmar() && Object.keys(nextProps.selectedNavBranch).length > 0 && (trip.stops || []).length > 0 && trip.stops[0].city && nextProps.selectedNavBranch.branch_name !== trip.stops[0].city) {
         const branchId = ((nextProps.selectedNavBranch || {}).branch_id);
         let findBranch = (nextProps.depotLocationList || []).find(depot => depot.branch_id === branchId);
         if(!findBranch) {
            findBranch = (nextProps.plantLocationList || []).find(depot => depot.branch_id === branchId);
         }
         if(findBranch && !findBranch.landmark) {
            findBranch.landmark = findBranch.address;
         }
         if(findBranch) {
            trip.stops[0].setLocation(findBranch);
            trip.stops[0].landmark = `${findBranch.landmark}${findBranch.pincode ? `, ${findBranch.pincode}`: ''}`;
         }
         this.setState({ trip });
      }
   }

   setLocation = (index, location) => {
      const { trip } = this.state;
      trip.stops[index].setLocation(location);
      
      let isIntera=trip.stops[1].city;
      if(isIntera==="Intra"){
       this.setState({isIntera})
       trip.stops[0].setLocation(location);
      }else if(['Open', 'Inter'].includes(isIntera)) {
         trip.branchTypeName="";
         trip.branchType="";
         trip.branchFromType="";
         trip.branchFromTypeName="";
      }
      this.setState({isIntera, trip}, () => {
         if(isAdaniWilmar() && this.props.secondaryContractType === 2) {
            const { trip } = this.state;
            this.props.dispatch({
               type: GET_ROUTE_CODE,
               data: {
                  from: (trip.stops[0].city || trip.stops[0].location || '').split(',')[0],
                  to: (trip.stops[1].city || trip.stops[1].location || '').split(',')[0],
                  companyId: getUser().companyId
               },
               onSuccess: (data) => {
                  trip.addRouteCode(data.route_code);
                  this.setState({
                     trip
                  })
               }
            })
         }
      })  
   }


   onChange = (e) => {
      const name = e.target.name;
		const value = e.target.value;
      const { trip } = this.state;
      trip[name] = value;
      if(name === 'routeCode') {
         trip.addRouteCode(value);
      }if(['fixed_price','fixed_price_uom_id','variable_cost','variable_cost_uom_id'].includes(name)) {
         trip[name] = value;
      } else {
         trip['set' + name.substr(0, 1).toUpperCase() + name.slice(1)](value);
      }
      this.setState({
         trip
      });
   }

   setVehicleType = (vehicleType) => {
      const { trip } = this.state;
      trip.vehicleType = vehicleType.value;
      trip.vehicleTypeName = vehicleType.name;
      trip.setVehicleType(vehicleType.value, vehicleType.name);
      this.setState({ trip }, () => {
         if(isAdaniWilmar() && trip.vehicleTypeName) {
            this.getLPPDetails();
         }
      });
   }

   setVehicleBodyType = (vehicleBodyType) => {
      const { trip } = this.state;
      trip.vehicleBodyType = vehicleBodyType.value;
      trip.vehicleBodyTypeName = vehicleBodyType.name;
      trip.setVehicleBodyType(vehicleBodyType.value, vehicleBodyType.name);
      this.setState({ trip });
   }

   setSecondaryToLocationType = (locationType) => {
      const { trip } = this.state;
      trip.locationType = locationType.value;
      trip.locationTypeName = locationType.name;
      trip.setSecondaryToLocationType(locationType.value, locationType.name);
      this.setState({
         ...trip,
         "locationType": locationType.value,
         "locationTypeName": locationType.name
      });
   }

   setUpToKm = (value) => {
      const { trip } = this.state;
      trip.secUptoKM = value.range;
      trip['set' + ('secUptoKM').substr(0, 1).toUpperCase() + ('secUptoKM').slice(1)](value.range);
      this.setState({ trip })
   }

   onOtherCostChange = (index, e) => {
      const { name, value } = e.target;
      const { trip } = this.state;
      
      trip.slabs[index][name] = value;
       trip.slabs[index]['set' + name.substr(0, 1).toUpperCase() + name.slice(1)](value);
      this.setState({
         trip
      }, () => {
         const slab = trip.slabs[index];
         if(isAdaniWilmar() && slab.fromKm && slab.toKm) {
            this.getLPPDetails(index);
         }
      }); 
   }
   addSlab = () => {
      const { trip } = this.state;

      trip.addSlab();
      trip.slabs[trip.slabs.length - 1]['set' + ('costChargeDesc').substr(0, 1).toUpperCase() + ('costChargeDesc').slice(1)](`Slab ${trip.slabs.length}`);
      if(trip.slabs.length === 1) {
         trip.slabs[0]['set' + ('fromKm').substr(0, 1).toUpperCase() + ('fromKm').slice(1)](+trip.secUptoKM);
      } else if(trip.slabs.length > 1) {
         const prevObjfromValue = trip.slabs[+trip.slabs.length - 2]['toKm'];
         trip.slabs[+trip.slabs.length - 1]['set' + ('fromKm').substr(0, 1).toUpperCase() + ('fromKm').slice(1)](+prevObjfromValue);
      }
      this.setState({
         trip
      });
   }

   deleteSlab = (index) => {
      const { trip } = this.state;
      trip.removeSlab(index);
      this.setState({
         trip
      });
   }

   addTrip = () => {
      this.props.addTrip(this.state.trip);

   }

   onChangeHC = (index, e) => {
      const { name, value, type } = e.target;
      const { trip } = this.state;
      trip.multiModeHeadingCharges[index][name] = (type === 'number') ? +value : value;
      this.setState({ trip });
   }

   addHC = () => {
      const { trip } = this.state;
      trip.multiModeHeadingCharges.push({
         headingChargesDescription: '',
         headingChargesBudget: '',
         headingChargesUnit: '',
         headingChargesMr: '',
         headingChargesLpp: '',
         headingChargesCp: '',
         headingChargesValue: ''
      })
      this.setState({ trip })
   }

   deleteHC = (index) => {
      const { trip } = this.state;
      trip.multiModeHeadingCharges.splice(index, 1);
      this.setState({ trip });
   }

   onChangeTat = (field, val) => {
      const { trip } = this.state;
      if (field === 'value') {
         const { name, value } = val.target;
         trip['setSecTat'](field, value);
      } else {
         trip['setSecTat'](field, val.value);
         trip['setSecTat']('name', val.name);
      }
      this.setState({
         trip
      });

   }
   
   setSecondaryBranch = (branchType) => {
      const { trip } = this.state;
      trip.branchType = branchType.value;
      trip.branchTypeName = branchType.label;
      trip.setSecondaryBranch(branchType.value, branchType.label);
      this.setState({
         trip
      });
   }

   setSecondaryFromBranch =(branchFromType)=>{
      const { trip } = this.state;
      trip.branchFromType = branchFromType.value;
      trip.branchFromTypeName = branchFromType.label;
      trip.setSecondaryFromBranch(branchFromType.value, branchFromType.label);
      this.setState({
         trip
      });

   }

   setClusterCode =(item)=>{
      const { trip } = this.state;
      this.setLocation(0, {
         location: item.from,
         city: item.from,
         state: item.from_state
      });
      this.setLocation(1, {
         location: (item.to || []).join(', '),
         city: (item.to || []).join(', '),
         state: item.to_state
      });
      trip.clusterCode = item.cluster_code;
      trip.setClusterCode(item.cluster_code);
      this.setState({
         trip
      });

   }

   buttonValidation = () => {
      
      const { trip } = this.state;   
      
      if ((isAdaniWilmar() ? this.props.secondaryContractType === 2 : true) && trip.stops && !(trip.stops.length > 0 && trip.stops.filter(stop => (stop.location || stop.city)).length === 2)) {
         return;
      } 
      else if (isAdaniWilmar() && this.props.secondaryContractType === 2 &&  trip.slabs && (trip.slabs.length === 0 ||  trip.slabs.length > 0 && !((trip.slabs.filter(slab => slab.fromKm && slab.toKm && slab.qbr && slab.businessVolume).length) === trip.slabs.length))) {
         return;
      } 
      // else if (trip.multiModeHeadingCharges && trip.multiModeHeadingCharges.length > 0 && !((trip.multiModeHeadingCharges.filter(multiHC => multiHC.headingChargesBudget).length) === trip.multiModeHeadingCharges.length)) {
      //    return;
      // } 
      // else if (!(trip.secUptoKM && trip.secKmRun)) {
      //    return;
      // }
      else if (!isAdaniWilmar() && !(trip.secKmRun) && this.state.isIntera !== "Intra") {
         return;
      }
      // else if (!((trip.id ? trip.originalQbr : trip.secondaryQbr) && trip.secUptoKM && trip.secKmRun)) {
      //    return;
      // }
   
      return true;
   }

   changeLandmark = (index, e) => {
      const { trip } = this.state;
      const stops = [...trip.stops];
		stops[index].landmark = e.target.value;

      this.setState({
         ...trip,
         stops
      })
   }

   onSaveRouteCode = () => {
      const { trip } = this.state;
      if(trip.stops[0].location && trip.stops[1].location) {
         this.props.dispatch({
            type: SAVE_ROUTE_CODE,
            data: {
                  from: (trip.stops[0].city || trip.stops[0].location || '').split(',')[0],
                  to: (trip.stops[1].city || trip.stops[1].location || '').split(',')[0],
                  distance: trip.distance,
                  distance_uom: "KM",
                  sap_code: trip.routeCode,
                  company_id: getUser().companyId,
                  is_distance_from_google: trip.distance ? false : true
            }
         })
      }
   }

   getLPPDetails = (index) => {
      const user = getUser();
      const { trip } = this.state;
      const { dispatch, secondaryContractType } = this.props;
      let rfqType = {};
      if(secondaryContractType === 2) {
         rfqType =  {
            companyId: (user && user.companyId) ? user.companyId : null,
            source: trip.stops[0].location,
            destination: trip.stops[1].location,
            from_range: trip.slabs[index]['fromKm'] && Number(trip.slabs[index]['fromKm']) || 0,
            to_range: trip.slabs[index]['toKm'] && Number(trip.slabs[index]['toKm']) || 0,
            rfq_type: 3
        }
      } else {
         rfqType =  {
            companyId: (user && user.companyId) ? user.companyId : null,
            source: trip.stops[0].location,
            vehicle_type: trip.vehicleTypeName,
            rfq_type: 3
         }
            
      }
      dispatch({
         type: GET_LPP_DETAILS,
         data: {
            rfqType
         },
         onSuccess: ((data)=> {
             if(data.rfqType) {
                 const { trip } = this.state;
                 if(this.props.secondaryContractType === 2) {
                     trip.slabs[index].lpp = data.rfqType.lpp.toString();
                 } else {
                    trip.setLpp(data.rfqType.lpp.toString());
                 }
                 this.setState({
                     trip
                 })
             }
         })
     });
   }

   render() {
      const { trip } = this.state;
      const { vehicleTypes, vehicleBodyTypes, hideAddTrip, secondaryContractType, secondaryToLocations, secondaryUpToKmList,branchesList, clusterDetails,businessVolumes,pricingBasis} = this.props;
    
     
      if(this.state.isIntera){
         this.state.isIntera
      }else if(this.props.trip){
         this.state.isIntera= this.props.trip.stops[1].city;
      }

      const isEmami = EMAMI.includes(getUser().companyId);

      return (
         <Fragment>
            <ResponsiveTable className={"box-shadow mb-20"}>
               <div className={'mt-20 pv-10 ph-10'}>
                  <div className="flex flex-middle mb-20 border-top">
                     {/* <div className="fs-14 table-text-color wt-50 pl-15"></div> */}
                    {isEmami && <div className="fBold fs-16 header-dark-color wt-150 pl-15">{"Cluster"}<sup className={'fs-16 error-color'}>*</sup></div>}
                     <div className="fBold fs-16 header-dark-color wt-150 pl-15">{  (this.state.isIntera ==="Intra") ? "From Name": "From"}<sup className={'fs-16 error-color'}>*</sup></div>
                     {(isAdaniWilmar() ? secondaryContractType === 2 : true) &&<div className={Cx("fBold fs-16 header-dark-color pl-15", {
                        'wt-300': isAdaniWilmar(),
                        'wt-150': !isAdaniWilmar()
                     })}>{`From Address`}</div>}
                     {(isAdaniWilmar() ? secondaryContractType === 2 : true) && <div className="fBold fs-16 header-dark-color wt-150 pl-15">To<sup className={'fs-16 error-color'}>*</sup></div>}
                   {this.state.isIntera ==="Intra" && <div className="fBold fs-16 header-dark-color wt-150 pl-15">Branch Name</div>}
                     {(isAdaniWilmar() ? secondaryContractType === 2 : true) && <div className={Cx("fBold fs-16 header-dark-color pl-15", {
                        'wt-300': isAdaniWilmar(),
                        'wt-150': !isAdaniWilmar()
                     })}>To Address</div>}
                     {!isAdaniWilmar() && <>
                     <div className="fBold fs-16 header-dark-color wt-150 pl-15">Description</div>
                     <div className="fBold fs-16 header-dark-color wt-100 pl-15">Minimum Km<sup className={'fs-16 error-color'}></sup></div>
                     </>}
                     {(isAdaniWilmar() ? secondaryContractType === 1 : true) && <div className="fBold fs-16 header-dark-color wt-200 pl-15">Vehicle Type</div>}
                     {(isAdaniWilmar() && secondaryContractType === 1) && <>
                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">Carrying Capacity(MT)</div>
                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">Fixed Km / Month</div>
                     </>}
                     {!isAdaniWilmar() && <>
                     <div className="fBold fs-16 header-dark-color wt-150 pl-15">Body Type</div>
                     <div className="fBold fs-16 header-dark-color wt-80 pl-15">No. of Vehicle</div>
                     <div className="fBold fs-16 header-dark-color wt-100 pl-15">KM Run ~
                     { this.state.isIntera !== "Intra" && <sup className={'fs-16 error-color'}>*</sup>}
                     </div>
                     {secondaryContractType === 2 &&
                        <Fragment>
                           <div className="fBold fs-16 header-dark-color wt-100 pl-15">Working Hrs/Day</div>
                           <div className="fBold fs-16 header-dark-color wt-100 pl-15">Working Hrs/Month</div>
                        </Fragment>
                     }
                     {secondaryContractType === 1 ?
                        <Fragment>
                           <div className="fBold fs-16 header-dark-color wt-80 pl-15">Plcmnt Time In Hrs</div>
                        </Fragment> :
                        <Fragment>
                           <div className="fBold fs-16 header-dark-color wt-150 pl-15">TAT</div>
                        </Fragment>
                     }
                     </>}
                     {isAdaniWilmar() && secondaryContractType === 2 && 
                     <> 
                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">TAT</div>
                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">Route Code</div>
                     </>
                     }
                     {/* <div className="fBold fs-16 header-dark-color wt-100 pl-15">QBR<sup className={'fs-16 error-color'}>*</sup></div> */}
                     {(isAdaniWilmar() && secondaryContractType === 1) && <>
                        <div className="fBold fs-16 header-dark-color wt-100 pl-15">LPP</div>
                        <div className="fBold fs-16 header-dark-color wt-100 pl-15">MR</div>
                     </>}
                     {(isAdaniWilmar() ? secondaryContractType === 1 : true) && <div className="fBold fs-16 header-dark-color wt-100 pl-15">QBR</div>}
                     {isSapDPL() && <div className="fBold fs-16 header-dark-color wt-200 pl-15">Fixed price</div> }
                     {isSapDPL() && <div className="fBold fs-16 header-dark-color wt-200 pl-15">Varibale cost</div> }
                     {(isAdaniWilmar() && secondaryContractType === 1) && <>
                        <div className="fBold fs-16 header-dark-color wt-250 pl-15">Extra / km cost</div>
                     </>}
                  </div>
             
                  <div className="flex flex-middle mb-10">
                     {/* <div className="fs-14 table-text-color wt-50 pl-15"></div> */}
                     {isEmami && <div className="fs-14 table-text-color wt-150 pl-15">
                        <Dropdown
                           onSelect={this.setClusterCode}
                           items={clusterDetails}
                           selectedItem={(clusterDetails || []).find((cluster) => {
                              return cluster.cluster_code === trip.clusterCode
                           })}
                           label="Select Cluster"
                           displayKey="cluster_code"
                           searchEnabled={true}
                        />
                     </div> || ''}
                     {this.state.isIntera !=="Intra" &&
                     <div className="fs-14 table-text-color wt-150 pl-15">
                        {isEmami ? 
                           <Input
                              value={trip.stops[0].location || ''}
                              onChange={this.changeLandmark.bind(this, 0)}
                              placeholder="Enter From"
                              className={`inBlock ${isAdaniWilmar() ? 'wt-300 pr-15' : ''}`}
                              readOnly={true}
                           />
                        :
                        <PlacesAutoComplete
                           setLocation={this.setLocation.bind(this, 0)}
                           value={trip.stops[0].location || ''}
                           isInputValue ={(this.state.isIntera === "Open")}
                        />}
                     </div>}
                     {this.state.isIntera ==="Intra" &&
                     <div className="fs-14 table-text-color wt-150 pl-15">
                        <Dropdown
                           onSelect={this.setSecondaryFromBranch}
                           items={branchesList}
                           selectedItem={branchesList.find((branch) => {
                           
                              return branch.label === trip.branchFromTypeName
                           })}
                           label="Select Branch"
                           displayKey="label"
                        />
                     </div>
                     }

                     {(isAdaniWilmar() ? secondaryContractType === 2 : true) && <div className={Cx("fs-14 table-text-color pl-15", {
                        'wt-150': !isAdaniWilmar(),
                        'wt-300': isAdaniWilmar()
                     })}>
                        <Input
                           value={trip.stops[0].landmark || ''}
                           onChange={this.changeLandmark.bind(this, 0)}
                           placeholder="Enter Address"
                           className={`inBlock ${isAdaniWilmar() ? 'wt-300 pr-15' : ''}`}
                        />
                     </div>}
                     {(isAdaniWilmar() ? secondaryContractType === 2 : true) && <div className="fs-14 table-text-color wt-150 pl-15">
                        {isAdaniWilmar() ? 
                           <PlacesAutoComplete
                           setLocation={this.setLocation.bind(this, 1)}
                           value={trip.stops[1].location || ''}
                           isInputValue ={(this.state.isIntera === "Open")}
                        /> :
                        <>
                        {isEmami ? 
                           <Input
                              value={trip.stops[1].location || ''}
                              onChange={this.changeLandmark.bind(this, 0)}
                              placeholder="Enter To"
                              className={`inBlock ${isAdaniWilmar() ? 'wt-300 pr-15' : ''}`}
                              readOnly={true}
                           /> :
                        <Dropdown
                              onSelect={(options) => {
                                 this.setLocation(1, { city: options.name })
                              }}
                              items={secondaryToLocations}
                              selectedItem={secondaryToLocations.find((locationType) => {
                                 return locationType.name === trip.stops[1].city 
                              })}
                              label="Select Location Type"
                              displayKey="name"
                           />}
                           </>
                           }
                     </div>}
                     {this.state.isIntera ==="Intra" &&
                     <div className="fs-14 table-text-color wt-150 pl-15">
                        <Dropdown
                           onSelect={this.setSecondaryBranch}
                           items={branchesList}
                           selectedItem={branchesList.find((branch) => {
                           
                              return branch.label === trip.branchTypeName
                           })}
                           label="Select Branch"
                           displayKey="label"
                        />
                     </div>
                     }
                     {(isAdaniWilmar() ? secondaryContractType === 2 : true) && <div className={Cx("fs-14 table-text-color pl-15", {
                        'wt-150': !isAdaniWilmar(),
                        'wt-300': isAdaniWilmar()
                     })}>
                        <Input
                           value={trip.stops[1].landmark || ''}
                           onChange={this.changeLandmark.bind(this, 1)}
                           placeholder="Enter Address"
                           className={`inBlock ${isAdaniWilmar() ? 'wt-300 pr-15' : ''}`}
                        />
                     </div>}
                     {!isAdaniWilmar() && <>
                     <div className="fs-14 table-text-color wt-150 pl-15">
                        <Input
                           value={trip.secName}
                           onChange={this.onChange}
                           name="secName"
                           placeholder="Description"
                        />
                     </div>
                     <div className="fs-14 table-text-color wt-100 pl-15">
                        <Input
                           value={trip.secUptoKM}
                           type="number"
                           onChange={this.onChange}
                           name="secUptoKM"
                           placeholder="Minimum Km"
                        />
                        {/* <Dropdown
                           onSelect={this.setUpToKm}
                           items={secondaryUpToKmList}
                           selectedItem={secondaryUpToKmList.find((UpTo) => {
                              return UpTo.range === trip.secUptoKM
                           })}
                           label="Select Km"
                           displayKey="range"
                        /> */}
                     </div>
                     </>}
                     {(isAdaniWilmar() ? secondaryContractType === 1 : true) && <div className="fs-14 table-text-color wt-200 pl-15">
                        <Dropdown
                           onSelect={this.setVehicleType}
                           items={vehicleTypes}
                           selectedItem={vehicleTypes.find((vehicleType) => {
                              return vehicleType.value === trip.vehicleType
                           })}
                           label="Select Vehicle Type"
                           displayKey="name"
                           searchEnabled={true}
                           searchPlaceholder={'Search Vehicle types'}
                        />
                     </div>}
                     {(isAdaniWilmar() && secondaryContractType === 1) &&
                     <>
                        <div className="fs-14 table-text-color wt-150 pl-15">
                           <Input
                              value={trip.carryingCapacity}
                              type="number"
                              onChange={this.onChange}
                              name="carryingCapacity"
                              placeholder="Carrying Capacity"
                           />
                        </div>
                        <div className="fs-14 table-text-color wt-150 pl-15">
                           <Input
                              value={trip.fixedKmPerMonth}
                              type="number"
                              onChange={this.onChange}
                              name="fixedKmPerMonth"
                              placeholder="Fixed KM / Month"
                           />
                        </div>
                     </> }
                     {!isAdaniWilmar() && <>
                     <div className="fs-14 table-text-color wt-150 pl-15">
                        <Dropdown
                           items={vehicleBodyTypes}
                           selectedItem={vehicleBodyTypes.find((vehicleBodyType) => {
                              return vehicleBodyType.value === trip.vehicleBodyType
                           })}
                           onSelect={this.setVehicleBodyType}
                           label="Select Vehicle Body Type"
                           displayKey="name"
                           searchEnabled={true}
                           searchPlaceholder={'Search Body Types'}
                        />
                     </div>

                     <div className="fs-14 table-text-color wt-80 pl-15">
                        <Input
                           value={trip.numberOfVehicle}
                           type="number"
                           onChange={this.onChange}
                           name="numberOfVehicle"
                           placeholder="No. Of Vehicle"
                        />
                     </div>

                     <div className="fs-14 table-text-color wt-100 pl-15">
                        <Input
                           value={trip.secKmRun}
                           type="number"
                           onChange={this.onChange}
                           name="secKmRun"
                           placeholder="KM Run ~"
                        />
                     </div>
                     {secondaryContractType === 2 &&
                        <Fragment>
                           <div className="fs-14 header-dark-color wt-100 pl-15">
                              <Input
                                 value={trip.workingHoursPerDay}
                                 type="number"
                                 onChange={this.onChange}
                                 name="workingHoursPerDay"
                                 placeholder="Hrs/Day"
                              />
                           </div>
                           <div className="fs-14 header-dark-color wt-100 pl-15">
                              <Input
                                 value={trip.workingDaysPerMonth}
                                 type="number"
                                 onChange={this.onChange}
                                 name="workingDaysPerMonth"
                                 placeholder="Hrs/Month"
                              />
                           </div>
                        </Fragment>
                     }
                     </>}
                     {(secondaryContractType === 2 || (isAdaniWilmar() && secondaryContractType !== 1)) ?
                        <div className="fs-14 table-text-color wt-150 pl-15 flex">
                           <Input
                              value={trip.secTat.value}
                              type="number"
                              onChange={this.onChangeTat.bind(this, 'value')}
                              name="secTat"
                              placeholder="TAT"
                              className="wt-50"
                           />

                           <Dropdown
                              items={[...TAT_UNITS]}
                              selectedItem={TAT_UNITS.find(tatUnit => { return trip.secTat.unit === tatUnit.value })}
                              name="unit"
                              displayKey="name"
                              label="Select Unit"
                              onSelect={this.onChangeTat.bind(this, 'unit')}
                              className="wt-100"
                           />

                        </div>
                        :
                        <>
                        {!isAdaniWilmar() ? <div className="fs-14 table-text-color wt-80 pl-15 flex">
                           <Input
                              value={trip.secTat.value}
                              type="number"
                              onChange={this.onChangeTat.bind(this, 'value')}
                              name="secTat"
                              placeholder="TAT"
                           />
                        </div> : ''}
                        </>
                     }
                     {(isAdaniWilmar() && secondaryContractType === 2) &&
                        <div className="fs-14 table-text-color wt-100 pl-15">
                        <Input
                           value={trip.routeCode || ''}
                           onChange={this.onChange}
                           name={"routeCode"}
                           placeholder="routeCode"
                           readOnly={true}
                           // onBlur={(e) => { if(e.target.value.length > 5) this.onSaveRouteCode() }}
                        />
                     </div>
                     }
                     {(isAdaniWilmar() && secondaryContractType === 1) &&
                        <>
                           <div className="fs-14 table-text-color wt-100 pl-15">
                              <Input
                                 value={trip.lpp}
                                 type="number"
                                 onChange={this.onChange}
                                 name={"lpp"}
                                 placeholder="LPP"
                              />
                           </div>
                           <div className="fs-14 table-text-color wt-100 pl-15">
                              <Input
                                 value={trip.marketRate}
                                 type="number"
                                 onChange={this.onChange}
                                 name={"marketRate"}
                                 placeholder="MR"
                              />
                           </div>
                        </>
                     }
                     {(isAdaniWilmar() ? secondaryContractType === 1 : true) && 
                        <div className="fs-14 table-text-color wt-100 pl-15">
                           <Input
                              value={trip.id ? trip.originalQbr : trip.secondaryQbr}
                              type="number"
                              onChange={this.onChange}
                              name={trip.id ? "originalQbr" : "secondaryQbr"}
                              placeholder="QBR"
                           />
                        </div>
                     }
                     {isSapDPL() &&
                        <Fragment>
                           <div className="fs-14 table-text-color wt-200 pl-15 flex">
                           <Input
                              value={trip.fixed_price}
                              type="number"
                              onChange={(event)=>{
                                 this.onChange(event)
                              }}
                              name="fixed_price"
                              placeholder="Fixed price"
                              className="wt-100"
                           />

                           <Dropdown
                              items={pricingBasis}
                              selectedItem={pricingBasis.find(ele => { return trip.fixed_price_uom_id === ele.value })}
                              name="fixed_price_uom_id"
                              displayKey="name"
                              label="Select Unit"
                              onSelect={(data)=>{
                              const event = {target:{
                                 name:'fixed_price_uom_id',
                                 value:data.value
                              }}
                              this.onChange(event)
                              }}
                              className="wt-100"
                           />

                        </div>
                        </Fragment>}
                     {isSapDPL() &&
                        <Fragment>
                           <div className="fs-14 table-text-color wt-200 pl-15 flex">
                           <Input
                              value={trip.variable_cost}
                              type="number"
                              onChange={(event)=>{
                                 this.onChange(event)
                              }}
                              name="variable_cost"
                              placeholder="Variable Cost,"
                              className="wt-100"
                           />

                           <Dropdown
                              items={pricingBasis}
                              selectedItem={pricingBasis.find(ele => { return trip.variable_cost_uom_id === ele.value })}
                              name="variable_cost_uom_id"
                              displayKey="name"
                              label="Select Unit"
                              onSelect={(data)=>{
                              const event = {target:{
                                 name:'variable_cost_uom_id',
                                 value:data.value
                              }}
                              this.onChange(event)
                              }}
                              className="wt-100"
                           />

                        </div>
                        </Fragment>}
                   
                     {(isAdaniWilmar() && secondaryContractType === 1) &&
                        <div className="fs-14 table-text-color wt-200 pl-15">
                           <Input
                              value={trip.extraCostPerKm}
                              type="number"
                              onChange={this.onChange}
                              name={"extraCostPerKm"}
                              placeholder=""
                           />
                        </div>
                     }
                  </div>

                  <AddOtherCosts
                     trip={trip}
                     onChange={this.onOtherCostChange}
                     addSlab={this.addSlab}
                     deleteSlab={this.deleteSlab}
                     onChangeHC={this.onChangeHC}
                     addHC={this.addHC}
                     deleteHC={this.deleteHC}
                     secondaryContractType={secondaryContractType}
                  />
						<div className={'mt-10 mb-40'}>
                     <div className={'col-3 inBlock'}></div>
                     <div className={'col-2 inBlock'}>
                     <button className={Cx("b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30", {
                        'notselectable': !this.buttonValidation()
                     })} onClick={this.addTrip}>Save</button>
                     <button className="b-20 ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 ml-20" onClick={hideAddTrip}>Cancel</button>
                     </div>
                  </div>
               </div>
            </ResponsiveTable>
         </Fragment >
      )
   }

}

export default connect()(SecondaryAddTrip);